import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, unref as _unref, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["data-maska", "type", "placeholder", "maxlength", "min"]
const _hoisted_7 = { class: "invalid-feedback" }

import { computed } from "vue";
import { vMaska } from "maska";

export interface IModal {
  $errors?: Array<{ $message: string }>;
  $error: any;
  $model: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    model: { default: null },
    type: { default: "text" },
    label: { default: "" },
    placeholder: { default: "" },
    errorMsg: { default: "Por favor, preencha este campo corretamente" },
    value: { default: "" },
    readOnly: { type: Boolean, default: false },
    maxLength: { default: null },
    minDate: { default: null },
    inputStyle: { default: null },
    required: { type: Boolean, default: false },
    mask: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const errorMessage = computed(() =>
  props.model && props.model.$errors
    ? props.model.$errors.find((e) => e)?.$message || props.errorMsg
    : props.errorMsg,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4, "*"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "labelContentEnd")
    ]),
    (_ctx.readOnly)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          class: "form-control form-disabled",
          value: _ctx.value,
          disabled: "",
          style: _normalizeStyle(_ctx.inputStyle)
        }, null, 12, _hoisted_5))
      : (_ctx.model)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.model.$error }]),
            "data-maska": _ctx.mask,
            lang: 'pt-BR',
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.$model) = $event)),
            type: _ctx.type,
            placeholder: _ctx.placeholder,
            style: _normalizeStyle(_ctx.inputStyle),
            maxlength: _ctx.maxLength ?? undefined,
            min: _ctx.minDate ?? undefined
          }, null, 14, _hoisted_6)), [
            [_unref(vMaska)],
            [
              _vModelDynamic,
              _ctx.model.$model,
              void 0,
              { trim: true }
            ]
          ])
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("small", null, _toDisplayString(errorMessage.value), 1)
    ]),
    _renderSlot(_ctx.$slots, "content")
  ]))
}
}

})